<template>
  <div :id="ifIe?'iechatSite':'chatSite'" >
    <h1>广场公告</h1>
    <!-- <div class="con" v-for="(item,index) in noticelist" :key="item.con" @click="goDetail(index)">
 【公告】{{ item.content}}
    </div> -->
    <ul>
      <li class="con"  v-for="(item,index) in noticelist" :key="item.con" @click="goDetail(index)">
        【公告】{{ item.content}}
      </li>
    </ul>
  </div>
</template>
<script>
import bus from "@/tool/bus";
export default {
  data() {
    return {
      // noticeList: "",
      // 公告列表
      noticelist: [],
      ifIe:false
    };
  },
  created() {
    this.getChatNotice();
  },
   mounted() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.ifIe = true;
    } else {
      this.ifIe = false;
    }
   },
  methods: {
    // 获取公告
    async getChatNotice() {
      const {data} = await this.axios.post(this.chatUrl + "/api/article/getArticleInfo",{category_id: 8,page_num: 2});
            if(data.code==0){
              this.noticelist=data.data.data
            }
    },
    // 获取公告,点击将内容和时间传递给详情页面
   async goDetail(i){
      const {data} = await this.axios.post(this.chatUrl + "api/article/getArticleDetail",{article_id:this.noticelist[i].id})
      // console.log(data,999999999999999);
      if(data.code==0){
        var con = data.data.content
        var time =data.data.create_time 
      }
      bus.$emit('noticListDetail',i,'chatSite',con,time)
    }
  }
};
</script>

<style scoped>
#chatSite {
  width: 100%;
  padding-top: 0.9375rem /* 15/16 */;
  padding-bottom: .625rem /* 10/16 */;
  text-align: left;
  box-sizing: border-box;
  z-index: 88;
  }
  #iechatSite{
  height: 25rem /* 266/16 */;
  width: 100%;
  padding-top: 0.9375rem /* 15/16 */;
  padding-bottom: .625rem /* 10/16 */;
  text-align: left;
  box-sizing: border-box;
  }
  #iechatSite h1{
    height: 1.1875rem /* 19/16 */;
    font-size: 1.125rem /* 18/16 */;
    color: #282828;
    padding-left: 0.8125rem /* 13/16 */;
  }
  #iechatSite ul{
     width: 100%;
    height: 100%;
    overflow: hidden;
  }
 #iechatSite ul .con {
      margin: 1.1875rem /* 19/16 */ 1.125rem /* 18/16 */ 1.25rem /* 20/16 */;
      /*padding-top: .9375rem 15/16; */
      height: 4.9375rem /* 79/16 */ ;
      font-size: .75rem /* 12/16 */;
      color: #5F5F5F;
      line-height: 1.5;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      cursor: pointer;
    }
    #iechatSite ul .con::nth-child(1){
      border-bottom: 1px solid #e3e3e3;
      }
 #chatSite h1 {
    height: 1.1875rem /* 19/16 */;
    font-size: 1.125rem /* 18/16 */;
    color: #282828;
    padding-left: 0.8125rem /* 13/16 */;
  }
 #chatSite ul {
    width: 100%;
    height: 100%;
    overflow: hidden;
     }
   #chatSite ul .con {
      margin: 1.1875rem /* 19/16 */ 1.125rem /* 18/16 */ 1.25rem /* 20/16 */;
      /* padding-top: .9375rem 15/16; */
      height: 4.9375rem /* 79/16 */ ;
      font-size: .75rem /* 12/16 */;
      color: #5F5F5F;
      line-height: 1.5;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      cursor: pointer;
    }
    #chatSite ul .con::nth-child(1){
      border-bottom: 1px solid #e3e3e3;
      }
 
</style>



// WEBPACK FOOTER //
// src/components/chatPlaza/chatSite.vue